module.exports = __webpack_public_path__ + "static/media/Oakbrook-Pointe-By-Laws-Amended-2007.a7e99dd6.pdf";